import React, { useEffect } from 'react';

interface AboutPopupProps {
  onClose: () => void;
}

const AboutPopup: React.FC<AboutPopupProps> = ({ onClose }) => {
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  return (
    <div className="modal show d-block" style={{ backgroundColor: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)' }} tabIndex={-1} onClick={onClose}>
      <div className="modal-dialog modal-lg modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
          <div className="modal-header border-bottom-0 pt-4 px-4">
            <h5 className="modal-title fw-bold">About AI Shopping Cart</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body px-4 pb-4">
            <div className="mb-4">
              <h6 className="fw-bold text-primary text-uppercase small mb-2">What this app does</h6>
              <p className="text-muted">Our Shopping Assistant Agent helps you find the best prices and options for your shopping list items across various e-commerce websites. Simply add items to your cart, and our AI agent will do the research for you!</p>
            </div>

            <div className="bg-warning bg-opacity-10 border border-warning border-opacity-20 p-3 rounded-3 mb-4">
              <h6 className="fw-bold text-warning-emphasis small mb-2"><i className="bi bi-exclamation-triangle-fill me-2"></i>Requirements</h6>
              <p className="small mb-3">You must provide a Gemini API Key in the settings and use our Chrome extension for the agent to function.</p>
              <a href="https://chromewebstore.google.com/detail/ai-shopping-cart/bhpgolaacmlhpoflfomangjboeombkkg" target="_blank" rel="noopener noreferrer" className="d-inline-block transition-hover">
                <img src="/chrome-web-store-badge.png" alt="Available in the Chrome Web Store" style={{ height: '50px' }}/>
              </a>
            </div>

            <div>
              <h6 className="fw-bold text-primary text-uppercase small mb-3">How to use</h6>
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="p-3 border rounded-3 h-100 bg-light bg-opacity-50">
                    <div className="fw-bold mb-1">1. Add Items</div>
                    <div className="small text-muted">Use the main search bar to add any product you're looking for.</div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="p-3 border rounded-3 h-100 bg-light bg-opacity-50">
                    <div className="fw-bold mb-1">2. Smart Search</div>
                    <div className="small text-muted">AI analyzes your items and starts background research across stores.</div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="p-3 border rounded-3 h-100 bg-light bg-opacity-50">
                    <div className="fw-bold mb-1">3. Compare Deals</div>
                    <div className="small text-muted">Expand any item to see a breakdown of prices and reasoning from different retailers.</div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="p-3 border rounded-3 h-100 bg-light bg-opacity-50">
                    <div className="fw-bold mb-1">4. Save Money</div>
                    <div className="small text-muted">Click the best price to jump straight to the store and complete your purchase.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer border-top-0 px-4 pb-4">
            <button type="button" className="btn btn-primary px-4 fw-bold" onClick={onClose}>Got it!</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPopup;
